import React, { useState } from 'react';
import './RecommendationsSelector.scss';
import { getIcon } from '@flybits/design-system';
import { RecommendedMetric } from 'pages/AnalyticsV2/types';
import { ReactComponent as IconPushSent } from 'pages/AnalyticsV2/CustomAnalytics/icons/push-sent.svg';
import { ReactComponent as IconPushOpened } from 'pages/AnalyticsV2/CustomAnalytics/icons/push-opened.svg';
import { ReactComponent as IconPushEngagement } from 'pages/AnalyticsV2/CustomAnalytics/icons/push-engagement.svg';
import { ReactComponent as IconContentClicked } from 'pages/AnalyticsV2/CustomAnalytics/icons/content-clicked.svg';
import { ReactComponent as IconExperienceEngagement } from 'pages/AnalyticsV2/CustomAnalytics/icons/experience-engagement.svg';
import { VISUALIZER_OPTIONS } from 'pages/AnalyticsV2/CustomAnalytics/CreateOrEditChart/constants';

const RECOMMENDED_METRICS: RecommendedMetric[] = [
  {
    icon: <IconPushSent />,
    metric: { key: 'push-sent', name: 'push notifications sent' },
    time: { period: 7, interval: 'day' },
    visualization: VISUALIZER_OPTIONS.BAR,
  },
  {
    icon: <IconPushOpened />,
    metric: { key: 'push-viewed', name: 'push notifications viewed' },
    time: { period: 7, interval: 'day' },
    visualization: VISUALIZER_OPTIONS.BAR,
  },
  {
    icon: <IconPushEngagement />,
    metric: { key: 'push-engaged', name: 'push engagement rate' },
    time: { period: 7, interval: 'day' },
    visualization: VISUALIZER_OPTIONS.BAR,
  },
  {
    icon: <IconContentClicked />,
    metric: { key: 'content-viewed', name: 'content viewed' },
    time: { period: 7, interval: 'day' },
    visualization: VISUALIZER_OPTIONS.BAR,
  },
  {
    icon: <IconExperienceEngagement />,
    metric: { key: 'content-engaged', name: 'total content engagement' },
    time: { period: 7, interval: 'day' },
    visualization: VISUALIZER_OPTIONS.BAR,
  },
];

const MAIN_CLASS = 'recommendation-selector';
const CLASSES = {
  INFO: `${MAIN_CLASS}__info`,
  LIST: `${MAIN_CLASS}__list`,
  ITEM: `${MAIN_CLASS}__item`,
};
interface RecommendationsSelectorProps {
  onChange: (recommendation: RecommendedMetric) => void;
}

const RecommendedItem: React.FC<{
  selected?: boolean;
  icon: JSX.Element;
  metric: { key: string; name: string };
  time: { period: number; interval: string };
  onClick: () => void;
}> = ({ selected, icon, metric, time, onClick }) => {
  return (
    <button onClick={onClick} className={`${CLASSES.ITEM} ${selected ? 'selected' : ''}`}>
      {icon} For the selected experience, show me <span>{`${metric.name}`}</span> in the past{' '}
      <span>{`${time.period} ${time.interval}s`}</span>
    </button>
  );
};
export default function RecommendationsSelector({ onChange }: RecommendationsSelectorProps) {
  const [selected, setSelected] = useState(0);
  const handleClick = (selectedIndex: number) => {
    onChange(RECOMMENDED_METRICS[selectedIndex]);
    setSelected(selectedIndex);
  };
  return (
    <section className={MAIN_CLASS}>
      <div className={CLASSES.INFO}>
        {getIcon('error', {})} In order to utilize recommendations make sure you have an experience selected
      </div>
      <ul className={CLASSES.LIST}>
        {RECOMMENDED_METRICS.map((metric, i) => (
          <RecommendedItem key={i} selected={i === selected} {...metric} onClick={() => handleClick(i)} />
        ))}
      </ul>
    </section>
  );
}
